import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/wall/u7-in-wall.png";
import { type Product } from "../../types";
import { wifiWall } from "../product-list-groups/wifiWall";
import {
  connectedDevices,
  customization,
  dimensions,
  integratedSwitch,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const u7InWall: Product = {
  id: "u7InWall",
  productTitle: "U7 In-Wall",
  description: "u7InWall.description",
  isNew: true,
  storePathParts: {
    category: UniFiChildCategorySlug.WiFiWall,
    productSlug: "u7-iw",
  },
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiWall,
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/u7-iw`],
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7InWall.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u7InWall.dimensions",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: wifiCoverage.id,
      value: {
        type: "translation",
        value: "u7InWall.wifiCoverage",
      },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "200+" },
    },
    {
      propertyId: integratedSwitch.id,
      value: {
        type: "translation",
        value: "u7InWall.integratedSwitch",
      },
    },
    {
      propertyId: "powerMethodPoe",
      value: {
        type: "string",
        value: "PoE/PoE+",
        asterisk: 1,
      },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u7InWall.uplink" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "u7InWall.wifiMounting",
      },
    },
    {
      propertyId: customization.id,
      value: { type: "boolean", value: false },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u7InWall.notes.1"],
};
